import React, { useEffect, useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import { getSubcategoryWiseContent } from "../../../services/getSubcategoryWiseContent";
import { Link } from "react-router-dom";
// import { getAllSubject } from "../../../services/getAllSubject";
import { getCategoryWiseSubcategory } from "../../../services/getCategoryWiseSubcategory";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import AssignmentList from "../../../Components/AssignmentList";
import Universities from "../../../Components/Universities";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const AssignmentWriting = () => {
  const subCategoryId = "6586dfe7d2f7eeadeea4fafa";
  const categoryId = "65524e633c005ef3b51907c9";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  

   const breadCrumbData=[
     { label: "Home", path: "/" },
   { label: "Assignment Help"},
    { label: "Do My Assignment", }
  ]
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>

      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection/>
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Benefits of DoubtQ Assignment Help Services"
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <AssignmentList subCategoryId={subCategoryId} title="Recently Completed Assignment Samples" description="Explore high-quality assignment samples completed by experts for students"/>
      <HelpSteps subCategoryId={subCategoryId} />
      <Milestonerewards categoryId={categoryId} />
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts title="Meet our Assignment Experts" description="Our professionals deliver high-quality assignments with an improved writing experience"/>
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps:1,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default AssignmentWriting;
